import { company } from '~/company/Company';
import type { CloudflareResizeOptions } from '~/components/CloudflareResponsiveImage/CloudflareResizeOptions';
import { getCloudflareUrl } from '~/components/CloudflareResponsiveImage/utils';

export const createCategoryUrl = ({ id }: { id: number | string }) => {
  return company.match({
    mcosmetic: `/c/${id}?showProducts=true`,
    default: `/c/${id}`,
  });
};

export const createProductUrl = ({ id }: { id: number | string }) => `/p/${id}`;

export const cfSrcForImage = (src: string, size?: CloudflareResizeOptions) => {
  const options = company.match({
    heimkaup: size ? { dpr: 2, ...size } : size,
    default: size,
  });

  return getCloudflareUrl(
    src,
    company.match({
      citydrinks:
        company.envVariables.REACT_APP_CLOUDFLARE_IMAGE_RESIZE_DOMAIN_OLD,
      default: company.envVariables.REACT_APP_CLOUDFLARE_IMAGE_RESIZE_DOMAIN,
    }),
    options,
  );
};
